jQuery(function ($) {
    const $roots = $('[data-products-overview]');
    if (!$roots.length) return;

    $roots.each(function () {
        const $root = $(this);
        const $items = $root.find('[data-po-item]');

        const $openBtn = $root.find('[data-po-open]');
        const $closeBtn = $root.find('[data-po-close]');
        const $backdrop = $root.find('[data-po-backdrop]');
        const $applyBtn = $root.find('[data-po-apply]');
        const $resetBtn = $root.find('[data-po-reset]');

        let pendingApply = false;

        function isPopupMode() {
            // Adjust breakpoint if needed
            return window.matchMedia('(max-width: 1439.5px)').matches;
        }

        function getSelectedValues(type) {
            return $root
                .find(`input[data-po-filter="${type}"]:checked`)
                .map(function () {
                    return $(this).val();
                })
                .get();
        }

        function applyFilters() {
            const flavours = getSelectedValues('flavour');
            const packs = getSelectedValues('pack');

            $items.each(function () {
                const $it = $(this);
                const f = ($it.data('flavour') || '').toString();
                const p = ($it.data('pack') || '').toString();

                const matchFlavour = !flavours.length || flavours.includes(f);
                const matchPack = !packs.length || packs.includes(p);

                $it.toggle(matchFlavour && matchPack);
            });

            pendingApply = false;
        }

        function resetFilters(shouldApplyNow) {
            $root.find('input[data-po-filter]').prop('checked', false);

            if (shouldApplyNow) {
                applyFilters();
            } else {
                pendingApply = true;
            }
        }

        function openPopup() {
            $root.addClass('is-filter-open');
            $('html').addClass('po-open');
        }

        function closePopup() {
            $root.removeClass('is-filter-open');
            $('html').removeClass('po-open');
        }

        // Collapsible groups
        $root.find('[data-po-toggle]').on('click', function () {
            const $group = $(this).closest('[data-po-group]');
            const $body = $group.find('[data-po-body]');

            $group.toggleClass('is-open');
            $body.stop(true, true).slideToggle(200);
        });

        // Open ALL groups by default
        $root.find('[data-po-group]').each(function () {
            const $g = $(this);
            const $b = $g.find('[data-po-body]');

            $g.addClass('is-open');
            $b.show();
        });

        // Desktop: apply immediately
        // Popup: do NOT apply on checkbox click (only mark pending)
        $root.on('change', 'input[data-po-filter]', function () {
            if (isPopupMode()) {
                pendingApply = true;
                return;
            }
            applyFilters();
        });

        // Open / Close popup
        $openBtn.on('click', function () {
            if (!isPopupMode()) return;
            openPopup();
        });

        $closeBtn.on('click', closePopup);
        $backdrop.on('click', closePopup);

        // Apply button (popup)
        $applyBtn.on('click', function () {
            applyFilters();
            closePopup();
        });

        // Reset: desktop applies immediately, popup waits for Apply
        $resetBtn.on('click', function () {
            const shouldApplyNow = !isPopupMode();
            resetFilters(shouldApplyNow);
        });

        // If user rotates / resizes: if leaving popup mode and there are pending changes, apply them.
        $(window).on('resize', function () {
            if (!isPopupMode() && pendingApply) {
                applyFilters();
            }
        });

        // Initial apply
        applyFilters();
    });
});
